module.exports = "/cyber/_next/static/images/faq-bg-desktop-fcaaee1549386125bc888802ad1899a0.jpg";